import { Fragment } from 'react';
import '../../styles.css';
import { t } from '@avalara/bat-apps-shared/i18n';
import type { Connector } from '@avalara/types/index';
import { onError } from '../../../helpers';
import { onSearch } from '../../../helpers/connector-selector';

type Props = {
  connectors: Array<Connector>;
  onSearchConnectors: (results: Array<Connector>, searchString: string) => void;
  onShowConnectorDetails: (arg0: Connector) => void;
  searchConnectorsResults: Array<Connector>;
  searchString: string;
  selectedConnector: Connector | null;
  fallbackImg: string;
  onShowOtherDetails: (arg0: boolean) => void;
  onActiveSearch: (arg0: boolean) => void;
  activeSearch: boolean;
};

const ConnectorSearch = ({
  connectors,
  selectedConnector,
  onShowConnectorDetails,
  onSearchConnectors,
  searchConnectorsResults,
  searchString,
  fallbackImg,
  onShowOtherDetails,
  onActiveSearch,
  activeSearch,
}: Props) => (
  <Fragment>
    <h2 className='clear'>{t('shared.headings.or-search-more-than-700-others')}</h2>
    <div className='search-container'>
      <div>
        <div className='search-input-container'>
          <input
            type='text'
            name='search'
            id='search'
            value={searchString}
            placeholder={t('shared.placeholders.find-your-platform')}
            onChange={(e) => {
              onSearch(e, onSearchConnectors, searchString, connectors);
              onActiveSearch(true);
            }}
            onFocus={(e) => {
              onSearch(e, onSearchConnectors, searchString, connectors);
              onActiveSearch(true);
            }}
            onBlur={() => onActiveSearch(false)}
            className={searchConnectorsResults.length > 0 ? 'search-results' : ''}
            autoComplete='off'
          />
          {activeSearch && searchString && (
            <div className='search-dropdown search-results-drop-down'>
              <ul>
                {searchConnectorsResults.map((r) => {
                  if (searchConnectorsResults.length === 1 && searchString.toLowerCase() === r.name.toLowerCase())
                    onShowConnectorDetails(r);
                  return (
                    <li key={r.name}>
                      <button type='button' tabIndex={0} onMouseDown={() => onShowConnectorDetails(r)} value={r.name}>
                        {r.name}
                      </button>
                    </li>
                  );
                })}
                {searchString.length >= 2 && (
                  <li>
                    <button
                      type='button'
                      tabIndex={0}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        onShowOtherDetails(true);
                      }}
                      value={"Can't find your connector?"}
                      data-ref='buy-account-shared.connector-store.connector-not-found'
                    >
                      {"Can't find your connector?"}
                    </button>
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>
        <div>
          {selectedConnector && selectedConnector.logo != null && (
            <img
              className='search-result-image'
              onError={(e) => onError(e, fallbackImg)}
              src={selectedConnector.logo}
              alt={selectedConnector.name}
            />
          )}
        </div>
      </div>
    </div>
    <div />
  </Fragment>
);

export default ConnectorSearch;
